// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__1niFL","icon":"style_icon__3pesI","header-content":"style_header-content__2RcSX","title":"style_title__1GRaR"};